import { EFrequency } from '@/context/borrower';

export function getFrequencyLabel(
    frequency: EFrequency | undefined
): string | undefined {
    switch (frequency) {
        case EFrequency.WEEKLY:
            return 'Weekly';
        case EFrequency.FORTNIGHTLY:
            return 'Fortnightly';
        case EFrequency.MONTHLY:
            return 'Monthly';
        default:
            return undefined;
    }
}
